import React from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';
import Section from 'components/section';
import { qsParse } from '@utils/url-utils';
import { COUNTRYCODE_LANG_MAP } from 'constants/country';
import { IHeaderProps } from 'containers/landing/header';
import Header from 'containers/ac-containers/header';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { useTranslation } from 'hooks/use-translation';

const cx = cls(styles);

/**
 *用户隐私协议
 *
 * @export
 */
export default function UserAgreement() {
	const headerProps: IHeaderProps = {};
	const lang = useSelector((state: ConnectState) => state.app.local);
	const { showCountry } = qsParse(window.location.href);
	// if (showCountry === '0' || lang === COUNTRYCODE_LANG_MAP.EN) {
	headerProps.showRight = false;
	headerProps.title = 'online tutoring';
	// }

	const { transData } = useTranslation('agreement');

	return (
		<>
			<Section className={cx('container')}>
				<div
					dangerouslySetInnerHTML={{
						__html: transData.user,
					}}
				/>
				<div
					dangerouslySetInnerHTML={{
						__html: transData.policy,
					}}
				/>
			</Section>
		</>
	);
}
